import { request } from '@umijs/max';
import type { HomeDashboardResponse, HomeProfileResponse } from '@/pages/home/data';

const OMS_HOME_BASE = '/oms/home';

export async function fetchHomeDashboard(params?: { s_year?: string; page?: number }) {
  return request<HomeDashboardResponse>(`${OMS_HOME_BASE}/dashboard`, {
    method: 'GET',
    params,
  });
}

export async function fetchHomeProfile() {
  return request<HomeProfileResponse>(`${OMS_HOME_BASE}/profile`, {
    method: 'GET',
  });
}
